import { SET_CONFIG } from './types'

// Set app config
export const setConfig = config => {
	return {
		type: SET_CONFIG,
		payload: config
	}
}